import { memo } from 'react';
import { Source, Layer } from 'react-map-gl';

type Props<P extends object = {}> = {
  geoJSON: GeoJSON.FeatureCollection<GeoJSON.Point, P>;
};

export const CUSTOMER_LOCATIONS_CLUSTERS_COUNTERS_LAYER = 'customerLocationsClustersCountersLayer';
export const CUSTOMER_LOCATIONS_CLUSTERS_SOURCE = 'customerLocationsClustersSource';
export const CUSTOMER_LOCATIONS_CLUSTERS_LAYER = 'customerLocationsClustersLayer';

export default memo(function CustomerLocationsClustersGLSource({ geoJSON }: Props) {
  return (
    <Source
      cluster
      type="geojson"
      id={CUSTOMER_LOCATIONS_CLUSTERS_SOURCE}
      data={geoJSON}
      tolerance={0.0001}
      clusterMaxZoom={11}
    >
      <Layer
        id={CUSTOMER_LOCATIONS_CLUSTERS_LAYER}
        type="circle"
        source={CUSTOMER_LOCATIONS_CLUSTERS_SOURCE}
        filter={['has', 'point_count']}
        paint={{
          'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
          'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40],
        }}
      />

      <Layer
        id={CUSTOMER_LOCATIONS_CLUSTERS_COUNTERS_LAYER}
        type="symbol"
        source={CUSTOMER_LOCATIONS_CLUSTERS_SOURCE}
        filter={['has', 'point_count']}
        paint={{
          'text-color': 'white',
        }}
        layout={{
          'text-field': '{point_count_abbreviated}',
          'text-size': 12,
        }}
      />
    </Source>
  );
});
